import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

const faqs: FaqItem[] = [
  {
    q: 'Kann das Kurskonzept eigenständig in der Einrichtung umgesetzt werden?',
    a: 'Ja. Die Kurskonzepte sind so aufgebaut, dass sie von Fachkräften und Kursleitungen der Einrichtung eigenständig durchgeführt und in die bestehende Arbeit integriert werden können. Zusätzlich werden regelmäßige Austauschtreffen angeboten, bei denen Erfahrungen geteilt, Fragen besprochen und konkrete Umsetzungssituationen gemeinsam reflektiert werden.',
  },
  {
    q: 'Wie kann ich die Methoden und Tools professionell einsetzen?',
    a: 'Zu jedem Kurskonzept gehört ein Videokurs für die Kursleitung, der nach dem Erwerb des Konzeptes zur Verfügung gestellt wird. Darin werden wichtige Grundlagen sowie die professionelle Anwendung der Methoden und Tools vermittelt.',
  },
  {
    q: 'Wie lässt sich das Kurskonzept in die bestehende Struktur integrieren?',
    a: 'Sehr flexibel. Die Module können über mehrere Wochen hinweg, als kompakter Blockkurs oder bedarfsgerecht mit einzelnen Modulen und Themen eingesetzt werden. Die Konzepte bieten eine klare Grundstruktur und gleichzeitig Raum für die individuelle Gestaltung durch die Einrichtung.',
  },
  {
    q: 'Fällt eine laufende Lizenzgebühr an?',
    a: 'Nein. Das Kurskonzept wird einmalig erworben und steht der Einrichtung anschließend dauerhaft zur Verfügung.',
  },
  {
    q: 'Für welche Zielgruppen sind die Konzepte geeignet?',
    a: 'Menschen mit geistiger Beeinträchtigung, Menschen mit psychischer Beeinträchtigung und besonderem Unterstützungsbedarf sowie Schülerinnen und Schüler im Übergang von Schule in Ausbildung und Beruf.',
  },
  {
    q: 'Was ist im Erwerb enthalten?',
    a: 'Ein komplett ausgearbeitetes Konzept für die eigenständige Durchführung: Handout für die Kursleitung mit Erläuterungen, Tipps und Hinweisen, Videokurs für die Kursleitung, strukturierte Kursmodule mit Inhalten und Durchführungshinweisen, passende Arbeitsblätter und Materialien, Teilnahmezertifikat und Feedbackbogen.',
  },
  {
    q: 'Wie läuft der Erwerb ab?',
    a: 'In drei Schritten: 1. Angebot erhalten (individuelles Angebot für das gewünschte Kurskonzept), 2. Angebot bestätigen (nach Bestätigung wird die Rechnung erstellt), 3. Zugang erhalten (nach Zahlungseingang wird der persönliche Zugangslink per E-Mail zugesandt – dauerhaft verfügbar).',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 text-primary-800 px-4 py-1.5 text-xs md:text-sm font-semibold">
            <i className="ri-question-line"></i>
            FAQ
          </span>
          <div className="mt-4">
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              Häufige Fragen
            </h2>
          </div>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={item.q}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900">
                    {item.q}
                  </span>
                  <span
                    className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                      open ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}